// FIXME: заюзать из vueuse, т.к. судя по исходникам есть какой-то подвох с iOS
/* @ts-expect-error dunno */
import type { MaybeRef } from 'vue';

interface ClickOutsideOptions {
  capture?: boolean
  ignore: MaybeRef<HTMLElement[]>
}

export function useClickOutside(target: MaybeRef<HTMLElement>, handle: (event: Event) => any, options?: ClickOutsideOptions) {
  let listen: boolean = true;

  const capture = options?.capture ?? false;
  const ignoreElements: MaybeRef<HTMLElement[]> = options?.ignore ?? [];

  function onClick(event: MouseEvent | TouchEvent) {
    if (!listen || !event.target)
      return;

    const targetElement = unref(target);
    if (!targetElement || targetElement === event.target)
      return;

    const eventTarget = event.target;
    const eventComposedPath = event.composedPath();

    if (eventComposedPath.includes(targetElement))
      return;
    if (
      unref(ignoreElements).some((ignoreTarget: MaybeRef<HTMLElement>) => {
        const ignoreElement = unref(ignoreTarget);
        return ignoreElement === eventTarget || eventComposedPath.includes(ignoreElement);
      })
    ) {
      return;
    }

    handle(event);
  }

  document.addEventListener('click', onClick, { passive: true, capture });

  onBeforeUnmount(() => {
    document.removeEventListener('click', onClick, { capture });
  });

  const stopListen = () => {
    listen = false;
  };

  const startListen = () => {
    listen = true;
  };

  return {
    stopListen,
    startListen,
  };
}
